export default "__VITE_ASSET__bca52a00__"